var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlooring(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgba(100,21,255,1)",
    height: "800px",
    width: "800px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 308.606 308.606",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    enableBackground: "new 0 0 308.606 308.606",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m268.968,292.562h-50.077l-.06,16.044h50.137c4.43,0 8.022-3.592 8.022-8.022s-3.591-8.022-8.022-8.022z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m221.251,173.246c4.43,0 8.022-3.592 8.022-8.022 0-4.43-3.592-8.022-8.022-8.022h-27.077c-4.256,6.053-11.252,9.841-18.904,9.841-1.81,0-3.603-0.224-5.358-0.644 0.57,3.872 3.896,6.846 7.926,6.846 5.44,0 1.51,0 13.684,0v123.683c0,4.43 3.592,8.022 8.022,8.022 4.43,0 8.022-3.592 8.022-8.022v-123.682c12.169,0 8.263,0 13.685,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.907,278.832v-75.386c0-2.192-0.509-4.354-1.487-6.315l-18.681-37.478 .89-3.277-17.467-6.059c-9.918-3.441-15.039-12.831-15.167-18.648l1.677-37.614 9.645,37.365c0.988,3.826 3.824,6.902 7.556,8.197l44.528,15.447c6.15,2.134 12.875-1.12 15.012-7.279 2.135-6.156-1.123-12.876-7.279-15.012l-38.551-13.373-8.742-33.866 16.536,24.583 4.406,1.528 7.305-26.887c2.547-9.375-2.988-19.039-12.362-21.586l-30.27-8.224c-9.374-2.547-19.039,2.988-21.586,12.362 0,0-15.335,57.694-23.073,84.92-1.078,3.792-1.764,7.834-0.003,11.704l19.313,42.425-24.326,67.684c-2.644,7.357 1.177,15.466 8.534,18.11 0.452,0.163 0.908,0.294 1.364,0.408h-38.042c-4.43,0-8.022,3.592-8.022,8.022s3.592,8.022 8.022,8.022h140.501v-16.044h-30.996c6.177-1.52 10.765-7.082 10.765-13.729zm-75.379,13.73c4.427-1.108 8.24-4.326 9.899-8.943l26.272-73.099c1.248-3.473 1.09-7.295-0.438-10.653l-14.258-31.321c-0.47-1.032-0.301-2.242 0.433-3.106 0.734-0.864 1.902-1.226 2.996-0.928 0.805,0.219 1.479,0.771 1.851,1.518l20.312,40.749v72.053c0,6.647 4.588,12.209 10.766,13.73h-57.833z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.239,
    cy: 26.044,
    r: 26.038
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlooring);
export default __webpack_public_path__ + "static/media/flooring.6bc7649c96db8cad3cdcb738993e6c8a.svg";
export { ForwardRef as ReactComponent };